import React, { forwardRef } from 'react';
import { ButtonHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: any;
  isLoading?: boolean;
  typeStepperBtn?: string;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      type = 'button',
      className = '',
      disabled = false,
      isLoading = false,
      onClick,
      id = '',
      typeStepperBtn,
      ...rest
    }: ButtonProps,
    ref
  ) => {
    const { t } = useTranslation();

    return (
      <button
        ref={ref}
        type={type}
        className={className}
        disabled={disabled || isLoading}
        onClick={onClick || (() => {})}
        id={id}
        data-kt-stepper-action={typeStepperBtn}
        data-kt-indicator="on"
        {...rest}
      >
        {isLoading ? (
          <>
            {t('forms.inputs.process-loader')}
            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
          </>
        ) : (
          children
        )}
      </button>
    );
  }
);

export default Button;
